import { createTheme } from '@mui/material/styles';

const isEmbedMode =
  typeof window !== 'undefined' &&
  ['1', 'true'].includes(
    new URLSearchParams(window.location.search).get('embed')
  );

const theme = createTheme({
  spacing: 8,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    mode: 'light',
    primary: {
      light: '#fff',
      main: '#000',
      dark: '#808080',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ee6c4d',
      main: '#ee6c4d',
      dark: '#ee6c4d',
      contrastText: '#fff',
    },
    success: {
      light: '#284C0D',
      main: '#284C0D',
      dark: '#284C0D',
      contrastText: '#fff',
    },
    background: {
      default: '#fff',
    },
    text: {
      primary: '#000',
      secondary: '#555',
      light: '#fff',
    },
  },
  typography: {
    fontFamily: 'Rubik',
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#fff',
          color: '#000',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff !important',
          fontSize: '14px',
        },
        input: {
          backgroundColor: '#fff !important',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: '14px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {},
        shrink: {
          transform: 'translate(14px, -9px) scale(0.75) !important',
        },
        outlined: {
          transition: 'all 0.2s ease',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)',
          },
          transform: 'translate(14px, 14px) scale(1)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff !important',
        },
        input: {
          backgroundColor: '#fff !important',
          padding: '13px 14px',
        },
      },
    },
    MuiSelect: {
      defaultProps: isEmbedMode
        ? {
            MenuProps: {
              autoFocus: false,
              disableAutoFocus: true,
              disableAutoFocusItem: true,
              disablePortal: true,
              disableRestoreFocus: true,
              disableScrollLock: true,
            },
          }
        : {},
      styleOverrides: {
        select: {
          backgroundColor: '#fff !important',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          '&&[class*="MuiOutlinedInput-root"] input': {
            padding: '6.5px 4px',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          fontSize: 12,
        },
        outlined: {
          color: '#616161',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          color: '#000',
          '&.Mui-selected': {
            backgroundColor: '#000',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#000',
              color: '#fff',
            },
          },
        },
      },
    },
    // Example for disabled buttons
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
        },
        contained: {
          '&.Mui-disabled': {
            backgroundColor: 'rgba(194, 194, 194, 0.6)',
            color: 'rgba(255,255,255, 0.6)',
          },
        },
      },
    },
  },
});

export default theme;
